import { Component, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { StudentProfile } from '../../pathways-ui/models/student-profile.model';
import { LangService } from '../../pathways-ui/services/lang.service';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { FormControl } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { RegisterModel } from 'src/app/models/register.model';
import { StudentPortalService } from 'src/app/services/student-portal.service';

@Component({
    selector: 'register-form',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnDestroy {
    title = 'pathways-student-portal';
    isIframe = false;
    loginDisplay = false;
    private readonly _destroying$ = new Subject<void>();

    studentProfile: StudentProfile | undefined;
    studentId: number | undefined;
    dateOfBirth: Date | undefined;
    registerUsing: 'email' | 'mobile' = 'email';

    dateToValidate = new FormControl(new Date(''));
    isValidDob = false;

    constructor(
        private _activeRoute: ActivatedRoute,
        private _translate: TranslateService,
        private _langService: LangService,
        private _auth: AuthService,
        private _portalService: StudentPortalService
    ) {}

    ngOnDestroy(): void {}

    getStudentBirthdayFromUrl() {
        this._activeRoute.paramMap.subscribe((params: ParamMap) => {
            this.studentId = Number(params.get('id'));
            var dateForValidation = this.dateToValidate.value;
            dateForValidation.setHours(12, 0, 0, 0);

            this.validateStudentDateOfBirth(
                this.dateToValidate.value.toLocaleDateString('en-ca')
            );
        });
    }

    fetchStudentDateOfBirth() {
        this._portalService.getStudentDob().subscribe((val) => {
            this.dateOfBirth = val;
        });
    }

    validateStudentDateOfBirth(dob: string) {
        this._portalService
            .validateDob(dob, this.studentId)
            .subscribe((val) => {
                this.isValidDob = val;
                if (this.isValidDob) {
                    const registerObj = this.createRegisterObj();
                    this._auth.getRegisterLink(registerObj).subscribe((val) => {
                        window.location.href = val.url;
                    });
                } else {
                    this.dateToValidate.setErrors({ incorrect: true });
                }
            });
    }

    async ngOnInit() {
        this._activeRoute.queryParamMap.subscribe((params) => {
            if (params.has('ui_locale')) {
                //this._translate.use(this._langService.currentLang);
                this._langService.currentLang = params.get('ui_locale') ?? 'en';
            }
        });

        this.isIframe = window !== window.parent && !window.opener;
    }

    async validateDateOfBirth() {
        this.getStudentBirthdayFromUrl();
        if (this.dateToValidate == undefined) {
            return;
        }
    }

    createRegisterObj(): RegisterModel {
        return {
            dateEntered: this.dateToValidate.value.toISOString(),
            studentId: this.studentId,
            lang: this._translate.currentLang ?? 'en',
        };
    }
}
